import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useRef } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { $getRoot, $insertNodes } from "lexical";

/** Loads HTML into the editor whenever the seed value changes. */
export function InitialHtmlPlugin(_ref) {
  var html = _ref.html;
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  var applied = useRef(null);
  useEffect(function () {
    if (html === applied.current) return;
    applied.current = html;
    editor.update(function () {
      var _$getRoot$getFirstChi;
      $getRoot().clear();
      if (!html) return;
      var dom = new DOMParser().parseFromString(html, "text/html");
      var nodes = $generateNodesFromDOM(editor, dom);
      $getRoot().select();
      $insertNodes(nodes);
      (_$getRoot$getFirstChi = $getRoot().getFirstChild()) === null || _$getRoot$getFirstChi === void 0 || _$getRoot$getFirstChi.selectStart();
    });
  }, [editor, html]);
  return null;
}

/** Emits the editor's HTML on every change. */
export function HtmlOnChangePlugin(_ref2) {
  var onChange = _ref2.onChange;
  var _useLexicalComposerCo3 = useLexicalComposerContext(),
    _useLexicalComposerCo4 = _slicedToArray(_useLexicalComposerCo3, 1),
    editor = _useLexicalComposerCo4[0];
  useEffect(function () {
    return editor.registerUpdateListener(function (_ref3) {
      var editorState = _ref3.editorState;
      editorState.read(function () {
        return onChange($generateHtmlFromNodes(editor));
      });
    });
  }, [editor, onChange]);
  return null;
}

/** Keeps the editor's editable state in sync with the readOnly prop. */
export function ReadOnlyPlugin(_ref4) {
  var readOnly = _ref4.readOnly;
  var _useLexicalComposerCo5 = useLexicalComposerContext(),
    _useLexicalComposerCo6 = _slicedToArray(_useLexicalComposerCo5, 1),
    editor = _useLexicalComposerCo6[0];
  useEffect(function () {
    editor.setEditable(!readOnly);
  }, [editor, readOnly]);
  return null;
}